import { createContext, useContext, useEffect, useState } from "react";
import { LoginContext } from "./Auth";
import { confirmSwal } from "./swal";
import { useTranslation } from "react-i18next";

export const MainContext = createContext();

const isStg = window?.location?.origin?.includes("stg");

export const AppContext = ({ children }) => {
    const { t, i18n } = useTranslation();
    const { user } = useContext(LoginContext);
    const [step, setStep] = useState(1);
    const [settingsServiceComponent, setSettingsServiceComponent] = useState("");
    const [forgotStep, setForgotStep] = useState(1);
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [regMethod, setRegMethod] = useState("");
    const [openMenu, setOpenMenu] = useState(false);
    const [businessPlan, setBusinessPlan] = useState(false);
    const [selectedPack, setSelectedPack] = useState({
        price: 0,
        discountPercent: 0,
    });
    const [openModal, setOpenModal] = useState(false);
    const [langModalVivible, setLangModalVisible] = useState(false);
    const [mobileLangVisivle, setMobileLangVisivle] = useState(false);
    const [addBoxOpen, setAddBoxOpen] = useState(false);
    const [profileModalIsOpen, setProfileModalIsOpen] = useState(false);
    const [searchToBoxModalOpen, setSearchToBoxModalOpen] = useState(false);
    const [editBoxOpen, setEditBoxOpen] = useState(false);
    const [dashboardPage, setDashboardPage] = useState("boxes");
    const [selectedBox, setSelectedBox] = useState([]);
    const [boxes, setBoxes] = useState([]);
    const [fakeUpdate, setFakeUpdate] = useState(false);
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const [sharedProfileModal, setSharedProfileModal] = useState(false);
    const [editBoxId, setEditBoxId] = useState("");
    const [registerSuccessMsg, setRegisterSuccessMsg] = useState("");
    const [hasCardOrdered, setHasCardOrdered] = useState(false);
    const [mySelfProfilView, setMySelfProfilView] = useState(false);
    const [profilEditModalVisible, setProfilEditModalVisible] = useState(false);
    const [profilEditModalType, setProfilEditModalType] = useState(null);
    const [profileData, setProfileData] = useState(null);
    const [notificationCount, setNotificationCount] = useState(0)
    const [alertBoxContent, setAlertBoxContent] = useState({
        isOpen: false,
        content: {
            title: "",
            message: "",
            iconType: "",
            btnValue: "",
            customComponent: null,
        },
    });
    const [customModalContent, setCustomModalContent] = useState({
        isOpen: false,
        content: {
            title: "",
            message: "",
            customComponent: null,
        },
    });

    const closeAndClearCustomModal = () => {
        setCustomModalContent({
            isOpen: false,
            content: {
                title: "",
                message: "",
                customComponent: null,
            },
        });
    };

    const closeAndClearAlertBox = () => {
        setAlertBoxContent({
            isOpen: false,
            content: {
                title: "",
                message: "",
                iconType: "",
                btnValue: "",
                customComponent: null,
            },
        });
    };

    const buyPacket = (data) => {
        setSelectedPack(data);
        setOpenModal(true);
    };

    useEffect(() => {
        const detectLng = async () => {
            if (i18n.language === "tr") {
                await i18n.changeLanguage("az");
            }
        };
        detectLng();
    }, [i18n]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setMobileLangVisivle(false);
            } else {
                setMobileLangVisivle(true);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (sharedProfileModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [sharedProfileModal]);

    const removeUserFromBox = (profileID) => {
        confirmSwal(
            t("boxDetails.delete"),
            "",
            t("boxDetails.yes"),
            t("boxDetails.no"),
            () => {
            },
            () => {
                const updatedBox = selectedBox.profiles.filter(
                    (data) => data.id !== profileID
                );
                user.boxes.filter((box) => {
                    if (box.id === selectedBox.id) {
                        box.profiles = updatedBox;
                    }
                    return box;
                });
                setFakeUpdate(!fakeUpdate);
            },
            t("confirmModal.grant"),
            t("confirmModal.deny")
        );
    };

    const globalStates = {
        step,
        setStep,
        phone,
        setPhone,
        email,
        setEmail,
        regMethod,
        setRegMethod,
        businessPlan,
        setBusinessPlan,
        selectedPack,
        setSelectedPack,
        openModal,
        setOpenModal,
        alertBoxContent,
        setAlertBoxContent,
        customModalContent,
        setCustomModalContent,
        isStg,
        langModalVivible,
        setLangModalVisible,
        mobileLangVisivle,
        addBoxOpen,
        setAddBoxOpen,
        editBoxOpen,
        setEditBoxOpen,
        dashboardPage,
        setDashboardPage,
        profileModalIsOpen,
        setProfileModalIsOpen,
        selectedBox,
        setSelectedBox,
        boxes,
        setBoxes,
        fakeUpdate,
        setFakeUpdate,
        searchToBoxModalOpen,
        setSearchToBoxModalOpen,
        sideBarOpen,
        setSideBarOpen,
        openMenu,
        setOpenMenu,
        sharedProfileModal,
        setSharedProfileModal,
        editBoxId,
        setEditBoxId,
        registerSuccessMsg,
        setRegisterSuccessMsg,
        forgotStep,
        setForgotStep,
        mySelfProfilView,
        setMySelfProfilView,
        profilEditModalVisible,
        setProfilEditModalVisible,
        profilEditModalType,
        setProfilEditModalType,
        profileData,
        setProfileData,
        settingsServiceComponent,
        setSettingsServiceComponent,
        notificationCount,
        setNotificationCount,
        hasCardOrdered,
        setHasCardOrdered,
        buyPacket,
        removeUserFromBox,
        changeLanguage,
        closeAndClearAlertBox,
        closeAndClearCustomModal,
    };

    return (
        <MainContext.Provider value={globalStates}>{children}</MainContext.Provider>
    );
};
